export default __webpack_public_path__ + "static/media/a011-example13_en.10c85f0b.png";